import React, {StrictMode} from "react";
import ReactDOM from "react-dom/client";
import { Global, ThemeProvider } from "@emotion/react";
import { BrowserRouter } from "react-router-dom";
import * as Sentry from "@sentry/react";
import App from "./app";
import "./config/validateEnv";
import { HelmetProvider } from "react-helmet-async";
import { PostHogProvider } from "posthog-js/react";
import { ApolloProvider } from "@apollo/client";
import { UserContextProvider } from "./context";
import ReactGA from "react-ga4";
import "./index.css";
import { config } from "./config";
import { theme, globalStyles } from "@repo-sapiens/theme";
import { getApolloClient } from "@repo-sapiens/graphql";
import { getNewToken } from "./services";

// Google analytics
ReactGA.initialize(import.meta.env.VITE_GOOGLE_MEASUREMENT_ID);

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: import.meta.env.VITE_APP_SENTRY_DSN,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    environment: import.meta.env.MODE,
  });
}

const options = {
  api_host: config.posthog.host,
};

const graphqlClient = getApolloClient({
  graphQlApiUrl: config.graphQLApiUrl,
  wsUrl: config.wsUrl,
  getNewToken: getNewToken,
  platform: "web",
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <StrictMode>
    <BrowserRouter>
      <ApolloProvider client={graphqlClient}>
        <PostHogProvider apiKey={config.posthog.key} options={options}>
          <UserContextProvider>
            <ThemeProvider theme={theme}>
              <HelmetProvider>
                <Global styles={globalStyles} />
                <App />
              </HelmetProvider>
            </ThemeProvider>
          </UserContextProvider>
        </PostHogProvider>
      </ApolloProvider>
    </BrowserRouter>
  </StrictMode>,
);
